import { useEffect } from 'react';

const useScrollRestoration = () => {
    const scrollPositions: { [key: string]: number } = {};
    let currentPath =
        typeof window !== 'undefined' ? window.location.pathname : '';

    useEffect(() => {
        if (
            typeof window === 'undefined' ||
            !('scrollRestoration' in window.history)
        ) {
            return;
        }

        let isBackNavigation = false;
        window.history.scrollRestoration = 'manual';

        const saveScrollPosition = (url: string) => {
            scrollPositions[url] = window.scrollY;
        };

        const restoreScrollPosition = (url: string) => {
            const scrollY = scrollPositions[url] ?? 0;
            window.scrollTo(0, scrollY);
        };

        const onBeforeUnload = () => {
            saveScrollPosition(window.location.pathname);
        };

        const onPopState = () => {
            isBackNavigation = true;
        };

        const onRouteChange = () => {
            const newPath = window.location.pathname;

            saveScrollPosition(currentPath);

            if (isBackNavigation) {
                restoreScrollPosition(newPath);
                isBackNavigation = false;
            } else {
                window.scrollTo(0, 0);
            }

            currentPath = newPath;
        };

        window.addEventListener('beforeunload', onBeforeUnload);
        window.addEventListener('popstate', onPopState);

        const originalPushState = window.history.pushState;
        window.history.pushState = function (...args) {
            originalPushState.apply(this, args);
            onRouteChange();
        };

        const originalReplaceState = window.history.replaceState;
        window.history.replaceState = function (...args) {
            originalReplaceState.apply(this, args);
            onRouteChange();
        };

        return () => {
            window.removeEventListener('beforeunload', onBeforeUnload);
            window.removeEventListener('popstate', onPopState);
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, []);
};

export default useScrollRestoration;
